import { SetupFinishStep } from "@/components/setup/setup-finish-step";

export const SetupResubscriptionBillingFinishPage = () => (
  <SetupFinishStep
    apiEndpoint="/my/team/setup/finish-resubscription"
    translationPrefix="setup.resubscriptionBilling.finish"
  />
);
